import React from 'react';

const DottedArrowIcon = ({
  width = 32.5,
  height = 60,
  color = '#FEFDFB',
  ...props
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 32.5 60'
    fill='none'
    {...props}
  >
    <circle cx='2.5' cy='2.5' r='2.15' fill={color} />
    <circle cx='11.67' cy='11.67' r='2.15' fill={color} />
    <circle cx='20.83' cy='20.83' r='2.15' fill={color} />
    <circle cx='30' cy='30' r='2.15' fill={color} />
    <circle cx='20.83' cy='39.17' r='2.15' fill={color} />
    <circle cx='11.67' cy='48.33' r='2.15' fill={color} />
    <circle cx='2.5' cy='57.5' r='2.15' fill={color} />
  </svg>
);

export default DottedArrowIcon;
